var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoStroke({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 31 31",
    enableBackground: "new 0 0 31 31",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#178FEB",
    d: "M15.5,5C21.3,5,26,9.7,26,15.5S21.3,26,15.5,26S5,21.3,5,15.5S9.7,5,15.5,5 M15.5,2C8,2,2,8,2,15.5 S8,29,15.5,29S29,23,29,15.5S23,2,15.5,2L15.5,2z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 13,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#178FEB",
    width: 3,
    height: 8
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#178FEB",
    width: 3,
    height: 3
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoStroke);
export default __webpack_public_path__ + "static/media/info-stroke.22fb5ee73309621ca8e4e6f70f1bdccf.svg";
export { ForwardRef as ReactComponent };